module.exports = __webpack_public_path__ + "img/cardLayout-03.52340ce5.png";